<template>
	<v-dialog
		v-if="connector"
		v-model="showDialog"
		width="500"
		min-height="400"
		persistent
	>
		<v-card>
			<v-card-title> Add Connector </v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-text-field
						label="Name"
						:rules="[(v) => !!v || 'Name is required']"
						v-model="selectedConnector.Name"
					>
					</v-text-field>
					<v-autocomplete
						clearable
						label="Parent Size Field"
						:rules="[(v) => !!v || 'Parent size field is required']"
						v-model="selectedConnector.ParentSizeGvfId"
						:items="gridViewFields"
						item-text="Label"
						item-value="Id"
					></v-autocomplete>
					<v-autocomplete
						clearable
						label="Parent Orientation Field"
						:rules="[
							(v) =>
								!!v || 'Parent orientation field is required',
						]"
						v-model="selectedConnector.ParentOrientationGvfId"
						:items="gridViewFields"
						item-text="Label"
						item-value="Id"
					></v-autocomplete>
					<v-autocomplete
						clearable
						label="Child Top Field"
						:rules="[(v) => !!v || 'Child top field is required']"
						v-model="selectedConnector.ChildTopGvfId"
						:items="gridViewFields"
						item-text="Label"
						item-value="Id"
					></v-autocomplete>
					<v-autocomplete
						clearable
						label="Child Bottom Field"
						:rules="[
							(v) => !!v || 'Child bottom field is required',
						]"
						v-model="selectedConnector.ChildBottomGvfId"
						:items="gridViewFields"
						item-text="Label"
						item-value="Id"
					></v-autocomplete>
					<v-autocomplete
						clearable
						label="Color Field"
						:rules="[(v) => !!v || 'Color field is required']"
						v-model="selectedConnector.ColorGvfId"
						:items="gridViewFields"
						item-text="Label"
						item-value="Id"
					></v-autocomplete>
				</v-form>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn @click.stop="onSave" color="primary">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { ConnectorsListGetters } from '../../../store/getters';
import { ConnectorsListActions } from '../../../store/actions';
import { connectorViewMode } from '../../../enums/connectorViewMode';
export default {
	name: 'ConnectorDetailsModal',
	props: {
		showDialog: Boolean,
		connector: Object,
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters({
			gridViewFields: [ConnectorsListGetters.GRID_VIEW_FIELDS],
			selectedGridView: [ConnectorsListGetters.SELECTED_GRID_VIEW],
		}),
		selectedConnector() {
			return Object.assign({}, this.connector);
		},
		viewModes() {
			return [
				{ Text: 'Grid', Value: connectorViewMode.Grid },
				{ Text: 'Image', Value: connectorViewMode.Image },
			];
		},
	},
	mounted() {
		this.selectedConnector.ViewMode = connectorViewMode.Grid;
	},
	methods: {
		onClose() {
			this.$emit('close');
			this.$refs.form.resetValidation();
		},
		// isImageViewMode(v) {
		//     if (this.selectedConnector.ViewMode == connectorViewMode.Image)
		//         return !!v;
		//     return true;
		// },
		onSave() {
			this.selectedConnector.GridViewId = this.selectedGridView.Id;
			if (this.$refs.form.validate())
				if (this.selectedConnector.Id) {
					this.$store
						.dispatch(
							ConnectorsListActions.UPDATE_CONNECTOR,
							this.selectedConnector
						)
						.then(() => {
							this.onClose();
						});
				} else {
					this.$store
						.dispatch(
							ConnectorsListActions.ADD_CONNECTOR,
							this.selectedConnector
						)
						.then(() => {
							this.onClose();
						});
				}
		},
	},
};
</script>
